import settings from 'settings'
import { useAppSelector } from 'app/state'

import { User, UserAccountJoinRequestStatus, UserMetadata } from 'features/users/types'

export function goToCompleteAccount() {
  localStorage.clear() // We don't want anything cached in this case
  const accountsUrl = `${settings.accountsUrl}/` // ensure proper root path in self hosted
  window.location.replace(accountsUrl)
}

export function isAccountReady(user: User | undefined) {
  if (!user) return false
  const user_metadata = user.user_metadata as UserMetadata | undefined

  if (
    !user_metadata ||
    !user_metadata?.account_id ||
    user_metadata?.account_join_request === UserAccountJoinRequestStatus.Waiting ||
    user_metadata?.account_join_request === UserAccountJoinRequestStatus.Declined
  ) {
    return false
  }
  return true
}

export function useIsAccountReady() {
  const user = useAppSelector((state) => state.users.me)

  const accountReady = isAccountReady(user)

  return { accountReady }
}
